
import { AppDispatch } from "@/redux"
import { appActions } from "@/redux/slice/appSlice"
import { WorkflowExecutionAPI } from "@/API/WorkflowExecution"
import { showNotification } from "./notificationService"
import { WorkflowMessage, formattedWorkflowMessage } from "@/constants/workflows/workflows"

export const getWorkflowExecutions = (
  token: string,
  workflowId: string,
  shouldLoad = true
) => async (dispatch: AppDispatch) => {
  shouldLoad && dispatch(appActions.setLoading(true))
  const resp = await WorkflowExecutionAPI.getWorkflowExecutions(token, workflowId)
  shouldLoad && dispatch(appActions.setLoading(false))
  return resp
}

export const getExecutionDetails = (
  token: string,
  executionId: string,
  shouldLoad = true
) => async (dispatch: AppDispatch) => {
  shouldLoad && dispatch(appActions.setLoading(true))
  const resp = await WorkflowExecutionAPI.getExecutionDetails(token, executionId)
  shouldLoad && dispatch(appActions.setLoading(false))
  return resp
}

export const reRunByExecutionId = (
  token: string,
  executionId: string
) => async (dispatch: AppDispatch) => {
  dispatch(appActions.setLoading(true))
  const resp = await WorkflowExecutionAPI.reRunByExecutionId(token, executionId)
  if (resp.data) {
    showNotification(
      resp,
      WorkflowMessage.RUN_SUCCESSFUL,
      formattedWorkflowMessage
    )
  }
  dispatch(appActions.setLoading(false))
  return resp
}

export const reRunStep = (
  token: string,
  stepId: string,
  shouldRunAllFollowingSteps: boolean
) => async (dispatch: AppDispatch) => {
  dispatch(appActions.setLoading(true))
  const resp = await WorkflowExecutionAPI.reRunStep(token, stepId, shouldRunAllFollowingSteps)
  if (resp.data) {
    showNotification(resp, resp.data?.message as string || '', {})
  }
  dispatch(appActions.setLoading(false))
  return resp
}
